const rootEl = document.getElementById('sample-popup-app');
const samplePopupApp = Vue.createApp({
    data() {
        return {
            materials: [],
            errors: null,
            loading: false,
            showModal: false,
            isMounted: false,
            cartAddUrl: '/cart/add.js',
            cartUpdateUrl: '/cart/update.js',
            cartUrl: '/cart.js',
            fetchHeaders: new Headers({'pragma':'no-cache','cache-control':'no-store','Content-Type':'application/json'}),
            item: null,
            variant: null,
            samples: window.sampleOptions
        }
    },
    props: ['url','selectedVariantId','onlyVariant'],
    watch: {
        materials(newNaterials) {
            if(newNaterials.length > 0) {
                this.errors = null;
            }
        },
    },
    computed: {
        image() {
            let img = '';
            if(this.item) {
                let variantImage = this.onlyVariant === 'false' && this.variant && this.variant.hasOwnProperty('featured_image') ? this.variant.featured_image.src : this.item.featured_image;
                if(!variantImage.startsWith('https')) {
                    variantImage = 'https:' + variantImage;
                }
                if(this.item.type === 'Canvas Wrap') {
                    img = 'https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos/?frame=canvas2&style=style1&size=600&url=' + variantImage;
                } else {
                    img = variantImage;
                }
            }
            return img;
        }
    },
    methods: {
        open() {
            this.showModal = true;
        },
        close() {
            this.showModal = false;
        },
        onSubmit() {
            if(this.item.type === 'Wall Mural' && this.materials.length === 0) {
                this.errors = true;
                return false;
            } else {
                this.loading = true;
                let properties = {
                    '_id': this.item.id,
                    '_url': this.url,
                    '_title': this.onlyVariant === 'false' && this.variant ? this.item.title + ' - ' + this.variant.title : this.item.title,
                    '_image': this.image,
                    'Materials': this.materials.join(', ')
                };
                const formData = new FormData();
                formData.set('id',window.sampleVariantId);
                formData.set('quantity',1);
                formData.set('sections', ["mini-cart"]);

                for(const key in properties) {
                    formData.set(`properties[${key}]`,properties[key]);
                }
                let ms = Date.now();
                let url = this.cartUrl + '?_=' + ms;
                fetch(url,{method: 'GET', headers: this.fetchHeaders})
                    .then((response) => response.json())
                    .then((parsedState) => {
                        return new Promise((resolve, reject) => {
                            if(parsedState.items.length === 0) {
                                resolve();
                            } else {
                                const samplesFound = parsedState.items.filter((item) => item.handle === 'sample' && this.item.id === parseInt(item.properties['_id']));
                                if(!samplesFound || samplesFound.length === 0) {
                                    resolve();
                                } else {
                                    let updates = {};
                                    samplesFound.forEach((sample) => {
                                        updates[sample.key] = 0;
                                    });
                                    const params = {
                                        "updates": updates
                                    };
                                    let body = JSON.stringify(params);
                                    fetch(this.cartUpdateUrl, {method: 'POST', headers: this.fetchHeaders , body})
                                        .then((response) => response.json())
                                        .then((response) => {
                                        })
                                        .catch((e) => {
                                            console.error(e);
                                        }).finally(() => {
                                            setTimeout(() => {
                                                resolve();
                                            },250);
                                        });
                                }
                            }
                        });
                    })
                    .then(() => {
                        fetch(this.cartAddUrl, {method: 'POST', body: formData})
                            .then((response) => response.json())
                            .then((response) => {
                            })
                            .catch((e) => {
                                console.error(e);
                            }).finally(() => {
                                fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
                                    const cartContent = await response2.json();
                                    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                                        bubbles: true,
                                        detail: {
                                            cart: cartContent
                                        }
                                    }));
                                    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                                        bubbles: true,
                                        detail: {
                                            cart: cartContent
                                        }
                                    }));
                                    rootEl.dispatchEvent(new CustomEvent("cart-notification:show", {
                                        bubbles: true,
                                        cancelable: true,
                                        detail: {
                                            status: "success",
                                            error: ""
                                        }
                                    }));
                                    this.loading = false;
                                    this.close();
                                });
                            });
                    });
            }
        }
    },
    created() {
        this.item = JSON.parse(document.getElementById('product-json').textContent);
        this.variant  = this.item.variants.find((v) => v.id === parseInt(this.selectedVariantId));
        const img = new Image();
        img.src = this.image;
    },
    mounted () {
        setTimeout(() => {
            this.isMounted = true;
            if(productVariantElement) {
                let masterSelectorForm = document.getElementById(productVariantElement.getAttribute("form-id"));
                if(masterSelectorForm) {
                    masterSelectorForm.addEventListener('variant:changed', (e) => {
                        this.variant = e.detail.variant;
                    });
                }
            }
        },250);
    },
    template: `
<teleport to="#requestSample" v-if="isMounted">
  <button class="product-form__add-button button button--primary button--full" @click.prevent="open"><span>REQUEST A SAMPLE</span></button>
</teleport>
  <transition name="modal">
    <div class="modal-mask" v-if="showModal">
      <div class="modal-wrapper" @click="close()">
        <div class="modal-container sample-popup-container" @click.stop="">
          <div class="modal-body">
            <div class="sample-order-form">
              <form action="/" method="post" @submit.prevent="onSubmit">
                <div class="sample-form" :class="{'loading': loading}">
                  <div class="sample-image">
                    <img :src="image" alt="">
                  </div>
                  <div class="title" v-if="item && item.type === 'Wall Mural'">Select Substrate Media</div>
                  <div class="sample-options" v-if="item && item.type === 'Wall Mural'">
                    <div v-for="(sample, index) in samples">
                      <p><strong>{{sample.title}}</strong></p>
                      <ul>
                        <li v-for="(sampleOption, jindex) in sample.options">
                          <input :id="'sample-'+index+'-'+jindex" type="checkbox" :value="sampleOption" v-model="materials" class="checkbox">
                          <label :for="'sample-'+index+'-'+jindex">{{sampleOption}}</label>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <p class="error" v-if="errors">Please select sample material</p>
                  <div class="actions">
                    <button type="submit" class="button btn-default"><span>Order Samples</span></button>
                  </div>
                </div>
              </form>
            </div>          
          </div>
          <button class="modal-close button button--close" @click="close()"><span class="sr-only">Close</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/></svg></button>
        </div>
      </div>
    </div>
    </transition>`
}, { ...rootEl.dataset })
samplePopupApp.mount('#sample-popup-app');
